'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _BillingTierFree = require('./BillingTierFree');

var _BillingTierFree2 = _interopRequireDefault(_BillingTierFree);

var _BillingTierPro = require('./BillingTierPro');

var _BillingTierPro2 = _interopRequireDefault(_BillingTierPro);

var _userUtil = require('../../../../../user/userUtil');

require('./BillingStatusDisplay.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BillingStatusDisplay = function BillingStatusDisplay(props) {
    return (0, _userUtil.isSubscribed)(props.currentUser) ? _react2.default.createElement(_BillingTierPro2.default, props) : _react2.default.createElement(_BillingTierFree2.default, props);
};

BillingStatusDisplay.propTypes = {
    currentUser: _propTypes2.default.object
};

exports.default = BillingStatusDisplay;


//////////////////
// WEBPACK FOOTER
// ./src/client/workspace/header/utils/account/billingStatus/BillingStatusDisplay.js
// module id = 2171
// module chunks = 0